export const CANADA = 'CA'
export const UNITED_STATES = 'US'

export const EUROPE_COUNTRIES = [
  'NL',
  'LU',
  'SM',
  'MK',
  'UA',
  'FO',
  'GI',
  'IS',
  'EE',
  'LT',
  'RS',
  'AD',
  'BE',
  'PT',
  'IM',
  'SK',
  'HR',
  'IT',
  'FI',
  'VA',
  'RU',
  'MT',
  'DE',
  'SJ',
  'SI',
  'AX',
  'RO',
  'BG',
  'JE',
  'AT',
  'MC',
  'FR',
  'AL',
  'LI',
  'MD',
  'IE',
  'ES',
  'BA',
  'GR',
  'GG',
  'BY',
  'LV',
  'ME',
]

export const COUNTRY_CURRENCY = {
  CA: 'CAD',
  AU: 'AUD',
  UK: 'GBP',
  GB: 'GBP',
  BR: 'BRL',
  IN: 'INR',
  MX: 'MXN',
  JP: 'JPY',
  ZA: 'ZAR',
  CZ: 'CZK',
  DK: 'DKK',
  HU: 'HUF',
  NO: 'NOK',
  NZ: 'NZD',
  PL: 'PLN',
  SG: 'SGD',
  SE: 'SEK',
  CH: 'CHF',
  HK: 'HKD',
}

export const REQUIRE_CREDIT_CARD_STATE_COUNTRIES = [CANADA, UNITED_STATES]
